<template>
  <div class="table-box">
    <xrk-back />
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item>
        <el-date-picker
          v-model="searchForm.createDt"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="操作时间起"
          end-placeholder="操作时间止"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="批次号" v-model="searchForm.batchNo"></el-input>
      </el-form-item>
      <el-form-item>
        <el-autocomplete
          class="inline-input"
          v-model="searchForm.operateUserName"
          :fetch-suggestions="querySearch"
          placeholder="操作人"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="全部操作详情"
          clearable
          v-model="searchForm.auditRecordState"
        >
          <el-option label="审核通过" value="2"></el-option>
          <el-option label="审核未通过" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="_initTableData">查询</el-button>
      </el-form-item>
    </el-form>
    <base-table
      :tableColumn="tableColumn"
      :data="tableData"
      v-loading="tableLoading"
    />
    <base-pagination
      v-model="tablePageQuery"
      :total="tableTotal"
      @input="_initTableData"
    />
  </div>
</template>

<script>
import { auditRecord } from '../api/index';
import xrkBack from '../components/bak.vue';
import baseTable from '../components/Base/baseTable';
import basePagination from '../components/Base/basePagination';
import taskCount from './task-count';
import createExtend from '@C/createExtend';
import baseTableMixin from '@C/Base/baseTableMixin';
import initProject from '../mixins/sync-project';

export default {
  name: 'task-check-log', //任务审核记录
  mixins: [baseTableMixin, initProject],
  components: {
    baseTable,
    basePagination,
    xrkBack
  },
  data() {
    return {
      tableColumn: [
        {
          type: 'index'
        },
        {
          prop: 'batchNo',
          label: '批次号'
        }, //批次号 xxxxp

        {
          prop: 'numberOfAuditTasks',
          label: '审核任务数',
          render: (h, { row }) => {
            const _this = this;
            const { numberOfAuditTasks, auditRecordState, id } = row;
            return h(
              'el-button',
              {
                props: {
                  type: 'text'
                },
                on: {
                  click: function() {
                    createExtend(taskCount, {
                      id,
                      auditRecordState,
                      numberOfAuditTasks
                    }).$on('refreshList', () => {
                      _this._initTableData();
                    });
                  }
                }
              },
              numberOfAuditTasks
            );
          }
        }, //批次号 xxxx
        {
          prop: 'operateUserName',
          label: '操作人'
        }, //操作时间起 yyyy-MM-dd HH:mm:ss
        {
          prop: 'createDt',
          label: '操作时间'
        }, //操作时间止 yyyy-MM-dd HH:mm:ss
        {
          prop: 'auditRecordState',
          label: '操作详情',
          formatter: ({ val }) => {
            return +val === 2 ? '审核通过' : '审核未通过';
          }
        }, //全部操作详情     2审核通过   3审核未通过
        {
          prop: 'remark',
          label: '备注'
        }
      ],
      searchForm: {
        createDt: '',
        operateUserName: '',
        auditRecordState: '',
        batchNo: '',
        projectId: this.$route.query.projectId
      }
    };
  },
  methods: {
    querySearch(value, cb) {
      auditRecord
        .getOperator({
          projectId: this.$route.query.projectId,
          fullName: value,
          pageNo: 1,
          pageSize: 50
        })
        .then(res => {
          const results = res.data.data.list.map(item => {
            return {
              value: item.fullName
            };
          });
          cb(results);
        });
    },
    async _initTableData() {
      this.searchForm.createDtStart =
        this.searchForm.createDt && this.searchForm.createDt[0];
      this.searchForm.createDtEnd =
        this.searchForm.createDt && this.searchForm.createDt[1];
      const {
        data: {
          data: { list, total }
        }
      } = await auditRecord.getList(
        Object.assign(this.searchForm, this.tablePageQuery)
      );
      this.tableData = list;
      this.tableTotal = total;
    }
  },
  created() {
    this._initTableData();
  }
};
</script>
